import api from '../http-common';

const index = (data) =>
  api.post('/feed-suppliers/index', data);

const store = (data) =>
  api.post('/feed-suppliers/store', data);

const edit = (id: number) =>
  api.post(`/feed-suppliers/${id}/edit`);

const update = (id: number, data) =>
  api.post(`/feed-suppliers/${id}/update`, data);

export const FeedSupplierService = {
  index,
  store,
  edit,
  update
};
